<template>
  <div class="layout">
    <site-nav></site-nav>
    <cere-header v-if="!['index','store','productDetail'].includes(this.$route.name) && this.terminal === 4" :componentContent="componentContent"></cere-header>
    <!-- <cere-header></cere-header> -->
    <div class="main">
      <router-view></router-view>
    </div>
    <Footer></Footer>
    <loading-toast ref="loadingToast"></loading-toast>
  </div>
</template>
<script>
  import Footer from '@/components/base/footer'
  import SiteNav from '@/components/base/siteNav'
  import CereHeader from '@/components/canvasShow/cereshop/pc/header'
  // 逻辑修改,由于目前头部导航部分是需要根据后台配置来生成,当前需要在layout组件层级就开始请求导航的配置数据  2021-06-21 徐昊
  import {listSearchMixin} from '../config/mixin'
  import api from '@/api'
  import LoadingToast from '@/components/canvasShow/components/toast'
  import {mapGetters, mapMutations} from 'vuex'
  export default {
    name: 'layout',
    components: {CereHeader, SiteNav, Footer,LoadingToast},
    mixins: [listSearchMixin],
    data () {
      return {
        componentContent:null
      }
    },
    props: {
      terminal: {
        type: Number,
        default: 4
      },
      typeId: {
        type: Number,
        default: 1
      },
      shopId: {
        type: Number,
        default: 0
      },
      canvasId: {
        type: Number,
        default: 0
      }
    },
    mounted(){
      this.canvasGet();
    },
    methods: {
      ...mapMutations({
      set_component : 'SET_componentContent' // 新增修改收货地址
    }),
      // 读取画布
      canvasGet () {
        var _this = this
        // this.$refs.loadingToast.setCanvasLoading(true)
        var apiUrl = api.getCanvas + '?terminal=' + this.terminal + '&type=' + this.typeId
        if (this.shopId) {
          apiUrl += '&shopId=' + this.shopId
        }
        if (this.canvasId) {
          apiUrl += '&canvasId=' + this.canvasId
        }
        let params = {
          url: apiUrl,
          method: 'GET'
        }
        this.sendReq(params, (res) => {
          this.$refs.loadingToast.setCanvasLoading(false)
          if (JSON.stringify(res.data) !== '{}') {
            var componentsData = JSON.parse(res.data.json)
            _this.set_component(componentsData)
            for(let i in componentsData){
              if(componentsData[i].type === 'shopHeader'){
                _this.componentContent = componentsData[i].componentContent
                break;
              }
            }
          }
          // console.log(JSON.parse(res.data.json))
        })
      }
    }
  }
</script>
<style scoped lang='scss'>
  .layout{
    height: 100%;
    overflow: auto;
    display: flex;
    flex-direction: column;
    
    .main{
      flex: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/layout.vue